import React from 'react'
import EqxButton from '../../shared/components/EqxButton/EqxButton'
import EqxEnvironmentBanner from '../../shared/components/EqxEnvironmentBanner/EqxEnvironmentBanner'
import { useTenantlessDeploymentContext } from './AppTenantlessDeploymentProvider'
interface AppOAuthRootLoginProps {
    error: string | null
    onLoginClick: () => void
}

/** Sign-in landing for `/` and `/switch` before MSAL establishes a session. */
const AppOAuthRootLogin = (props: AppOAuthRootLoginProps) => {
    const deployment = useTenantlessDeploymentContext()

    React.useEffect(() => {
        document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        document.body.classList.add('page-login')

        return () => {
            document.body.className = document.body.className.replace(/\bpage-\S+/g, '')
        }
    }, [])

    return (
        <>
            <EqxEnvironmentBanner
                environment={deployment.environment}
                instance={deployment.instance}
            />
            <div id="login-container">
                <div id="login-outer-title" style={{ fontSize: 20, textShadow: '0', color: '#999' }}>
                    <span>Continuum Go</span>
                </div>
                <div id="login">
                    <div id="login-header">
                        <img src="/images/logo-no-text.svg" alt="Continuum Go" id="login-logo" />
                        <img src="/images/logo-text.svg" alt="" id="login-logo-text" style={{ height: 20 }} />
                    </div>
                    <div id="login-body">
                        {props.error ? <div className="alert alert-danger">{props.error}</div> : null}
                        <EqxButton onClick={() => props.onLoginClick()} size="lg" variant="primary" id="login-button">
                            <>
                                <span className="fab fa-windows me-2"></span>
                                Sign in with Microsoft
                            </>
                        </EqxButton>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AppOAuthRootLogin
